import React from 'react'
import { useTranslation } from 'react-i18next'

import { ScaledRecipe } from '@/api/types'
import { MACROS, MICRO_NUTRIENTS, NUTRIENT_MAPPING } from '../../constants'
import { getNutrientsForUser } from '../../utils'
import './MealNutrition.css'

type Props = {
  scaledRecipes: ScaledRecipe[]
  mainUserId: number
} & React.HTMLAttributes<HTMLDivElement>

const NUTRIENTS = [...MACROS, ...MICRO_NUTRIENTS]

export default function MealNutrition({ scaledRecipes, mainUserId, style }: Props) {
  const { t } = useTranslation()

  const [nutritionalValue] = React.useMemo(() => {
    return [getNutrientsForUser(scaledRecipes, mainUserId)]
  }, [scaledRecipes, mainUserId])

  function roundNutrientValue(value: number) {
    if (isNaN(value) || value === 0) {
      return 0
    }
    if (value < 1) {
      return value.toFixed(2)
    }
    return Math.round(value)
  }

  return (
    <div className="MealNutrition" style={style}>
      <div className="title">{t('mealNutrition')}</div>
      <div className="energy">
        <div className="energy-big">Energy</div>
        <div className="energy-value">{Math.round(nutritionalValue.energy)}</div>
      </div>

      {NUTRIENTS.map((nutrient) => (
        <div key={nutrient} className="nutrientRow">
          <div>{t(`nutrient.${nutrient}` as any)}</div>
          <div>{roundNutrientValue(nutritionalValue[NUTRIENT_MAPPING[nutrient]])} g</div>
        </div>
      ))}
    </div>
  )
}
